import Wave from './wave';

class WaveGroup {
    constructor(maximumTotalWaves, maxiumHeight){
        this.color = ["#FC5D31", "#FE6082", ,"#45BAD9", "#18A2B1", "#1693CC", "#1D2C54"];
        this.totalWaves = maximumTotalWaves;
        this.maxiumHeight = maxiumHeight;

        // this.totalPoints = Math.floor(Math.random()*10) - 3;

        this.waves = [];

        for (let i = 0; i < this.totalWaves; i++){
            this.totalPoints = 9;

            const wave = new Wave(
                    i,
                    this.totalPoints,
                    this.color[i % this.color.length],
                    this.maxiumHeight
                );
            this.waves[i] = wave;
        }
    }

    resize(stageWidth, stageHeight){
        for (let i = 0; i < this.totalWaves; i++){
            const wave = this.waves[i];
            wave.resize(stageWidth, stageHeight);
        }
    }

    draw(ctx, totalWaves, maxiumHeight){
        for (let i = 0; i < totalWaves; i++){
            const wave = this.waves[i];
            wave.draw(ctx, maxiumHeight);
        }
    }
}

export default WaveGroup;



// WEBPACK FOOTER //
// ./src/layout/art/wavegroup.js